import { X } from "lucide-react";

const TestResultsTable = ({ tests, onRemove, title, type }) => {
  if (tests.length === 0) return null;

  return (
    <div className="mt-4">
      <h4 className="font-semibold text-gray-700 mb-3">{title}</h4>

      {/* Desktop Table View */}
      <div className="hidden md:block overflow-x-auto">
        <table className="w-full border-collapse bg-white rounded-lg shadow-sm">
          <thead>
            <tr className="bg-gray-50">
              <th className="text-left py-3 px-4 font-semibold text-gray-700 border-b">
                Category
              </th>
              <th className="text-left py-3 px-4 font-semibold text-gray-700 border-b">
                Sub-category
              </th>
              <th className="text-left py-3 px-4 font-semibold text-gray-700 border-b">
                Test Name
              </th>
              <th className="text-left py-3 px-4 font-semibold text-gray-700 border-b">
                Type
              </th>
              <th className="text-center py-3 px-4 font-semibold text-gray-700 border-b">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {tests.map((test, i) => (
              <tr key={i} className="hover:bg-gray-50">
                <td className="py-3 px-4 border-b">{test[1]}</td>
                <td className="py-3 px-4 border-b">{test[2]}</td>
                <td className="py-3 px-4 border-b">{test[3]}</td>
                <td className="py-3 px-4 border-b">
                  {test[type === "pathology" ? 5 : 6]}
                </td>
                <td className="py-3 px-4 border-b text-center">
                  <button
                    onClick={() => onRemove(i)}
                    className="text-red-600 hover:text-red-800 font-medium"
                  >
                    <X size={18} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile Card View */}
      <div className="md:hidden space-y-3">
        {tests.map((test, i) => (
          <div key={test[3]} className="card">
            <div className="flex justify-between items-start mb-3">
              <h3 className="font-semibold text-gray-800 text-sm leading-tight">
                {test[3]}
              </h3>
              <button
                onClick={() => onRemove(i)}
                className="text-red-600 hover:text-red-800 font-medium ml-2 flex-shrink-0"
              >
                <X size={24} />
              </button>
            </div>

            <div className="space-y-2 text-sm">
              <div className="flex">
                <span className="font-medium text-gray-600 w-32 flex-shrink-0">
                  <b>Category:</b>
                </span>
                <span className="text-gray-800">{test[1]}</span>
              </div>

              <div className="flex">
                <span className="font-medium text-gray-600 w-32 flex-shrink-0">
                  <b>Sub-category:</b>
                </span>
                <span className="text-gray-800">{test[2]}</span>
              </div>

              <div className="flex">
                <span className="font-medium text-gray-600 w-32 flex-shrink-0">
                  <b>Type:</b>
                </span>
                <span className="text-gray-800">
                  {test[type === "pathology" ? 5 : 6]}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TestResultsTable;
